import get from 'lodash/get';
import noop from 'lodash/noop';
import superagent from '@ott/superagent';
import { ENDPOINT_SUGGEST } from '../../../consts';
import { SUGGEST_GET_START, SUGGEST_GET_SUCCESS, SUGGEST_GET_FAIL } from '../types';
import processSuggestResponse from '../../../utilities/processSuggestResponse';

let currentRequest;

const requestSuggestedPoints = ({ directionType, term, lang, isTest }) => async dispatch => {
  dispatch({ type: SUGGEST_GET_START, directionType });
  const params = {
    term,
    lang,
    isTest,
  };

  get(currentRequest, 'abort', noop)();
  currentRequest = await superagent
    .post(ENDPOINT_SUGGEST)
    .timeout(10000)
    .send(params)
    .catch(error => {
      dispatch({
        type: SUGGEST_GET_FAIL,
        error,
        directionType,
      });
    });

  if (currentRequest) {
    const { error, isTest: testPage = false, airports, stations } = get(currentRequest, 'body', {});
    if (error) {
      dispatch({
        type: SUGGEST_GET_FAIL,
        error,
        directionType,
      });
    } else {
      dispatch({
        type: SUGGEST_GET_SUCCESS,
        isTestResponse: testPage,
        points: processSuggestResponse(airports, stations),
        directionType,
      });
    }
  }
};

export default requestSuggestedPoints;
